import { PlayButton } from '@southfields-digital/mpxlive-components';

import styles from '../MatchControl.module.scss';

import AdjustButton from './AdjustButton';

type ExtraInProps = {
  isRunning?: boolean;
  handleChangeExtraTime: (amount: number) => void;
  handleToggleIsExtraTimeLive: () => void;
  extraTime: number;
};

const ExtraIn = ({
  isRunning = false,
  handleChangeExtraTime,
  handleToggleIsExtraTimeLive,
  extraTime,
}: ExtraInProps) => (
  <div className={styles.ExtraInWrapper}>
    <div className={styles.ActionsWrapper}>
      <AdjustButton
        onClick={() => handleChangeExtraTime(-1000)}
        iconProps={{ icon: 'minus', weight: 'bold', size: 20 }}
        disabled={extraTime <= 0}
      />

      <AdjustButton
        onClick={() => handleChangeExtraTime(1000)}
        iconProps={{ icon: 'plus', weight: 'bold', size: 20 }}
      />
    </div>
    <PlayButton
      isRunning={isRunning}
      onClick={handleToggleIsExtraTimeLive}
      className="!h-9 w-full place-content-center !text-lg"
    >
      EXTRA
    </PlayButton>
  </div>
);

export default ExtraIn;
